import React from 'react';
import styles from './styles.module.css';

function ToggleSwitch({ checked, onClick }){
    return(
        <label className={styles.switch}>
            <input type="checkbox" checked={checked} onClick={onClick} />
            <span className={styles.slider}></span>
        </label>
    )
}

export default ToggleSwitch